import DeleteIcon from "components/Icons/DeleteIcon";
import { usePlaceAlertContext } from "./AlertContext";
import { IPlace } from "models/place";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import EditIcon from "components/Icons/EditIcon";
import { FaLocationPin } from "react-icons/fa6";

interface IProps {
  place: IPlace;
}

export default function Action({ place }: IProps) {
  const { showDelete } = usePlaceAlertContext();

  const handleClick = () => {
    showDelete(place);
  };

  return (
    <div className="flex items-center justify-center gap-x-3">
      <Link
        to={RouteName.VIEW_PLACES_ON_MAP}
        state={{ selectedPlaceId: place.id }}
        className="rounded-ful text-blue-600 hover:text-blue-800"
        title="View on Map"
      >
        <FaLocationPin />
      </Link>
      <Link
        to={RouteName.EDIT_PLACE.replace(":id", place.id)}
        state={place}
        className="rounded-ful text-black hover:text-black"
        title="Edit Place"
      >
        <EditIcon />
      </Link>
      <button 
        onClick={handleClick} 
        className="rounded-ful text-red-600 hover:text-red-800"
        title="Delete Place"
      >
        <DeleteIcon />
      </button>
    </div>
  );
}
